module.exports = __webpack_public_path__ + "img/grinning.9ae9b0ed.png";